export const REDUCER_NAME = 'whatsapp-messages'



// WEBPACK FOOTER //
// ./src/modules/whatsapp-messages/state/const.js